import { render, staticRenderFns } from "./studentsTableTrial.vue?vue&type=template&id=0d8f1b60&scoped=true&"
import script from "./studentsTableTrial.vue?vue&type=script&lang=js&"
export * from "./studentsTableTrial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8f1b60",
  null
  
)

export default component.exports